import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root',
})
export class PrevConfigurationService {
  // private checklistExecPMDataSubject = new BehaviorSubject<any>(null);
  get NotificationUrl(): string { return Constants.API_SIGNALR_BASE_URL; }
  get CoreUrl(): string { return Constants.CORE_API_BASE_URL; }
  private checklistExecPMData: any;
  private dataChangeCallbacks: (() => void)[] = [];
  constructor(private http: HttpClient) {}

  // setChecklistExecPMData(data: any): void {
  //   this.checklistExecPMDataSubject.next(data);
  // }

  // getChecklistExecPMData(): Observable<any> {
  //   return this.checklistExecPMDataSubject.asObservable();
  // }

  setChecklistExecPMData(data: any): void {
    this.checklistExecPMData = data;
    this.dataChangeCallbacks.forEach((cb) => cb());
  }

  getChecklistExecPMData(): any {
    return this.checklistExecPMData;
  }

  onDataChange(callback: () => void): void {
    this.dataChangeCallbacks.push(callback);
  }

  getTaskType(headerData: any): Observable<any[]> {
    // return this.http.get<any>(this.baseUrl + 'get-task-type', { params: headerData });
    return this.http.get<any>(this.CoreUrl + 'PMTaskType/getPMTaskType', {
      params: headerData,
    });
  }
  getPMTechnicianTaskByComponent(headerData: any): Observable<any[]> {
    // return this.http.get<any>(this.baseUrl + 'get-task-type', { params: headerData });
    return this.http.get<any>(
      this.CoreUrl + 'PMTask/GetPMTechnicianTaskByComponent',
      { params: headerData }
    );
  }

  addTaskType(data: any): Observable<any[]> {
    // return this.http.post<any>(this.baseUrl + 'add-task-type', data);
    return this.http.post<any>(this.CoreUrl + 'PMTaskType/addPMTaskType', data);
  }

  updateTaskType(data: any): Observable<any[]> {
    // return this.http.put<any>(this.baseUrl + 'update-task-type', data);
    return this.http.put<any>(
      this.CoreUrl + 'PMTaskType/updatePMTaskType',
      data
    );
  }
  getUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.CoreUrl + 'Dashboard/GetUnitListByLine',
      data
    );
  }

  getUnitByLineList(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.CoreUrl + 'Dashboard/GetUnitListByLineList',
      data
    );
  }

  deleteTaskType(data: any): Observable<any> {
    // return this.http.delete<any>(this.baseUrl + `delete-task-type/${data.ID}`);
    return this.http.delete<any>(
      this.CoreUrl + `PMTaskType/deletePMTaskType/${data.ID}`
    );
  }

  getTool(headerData: any): Observable<any[]> {
    // return this.http.get<any>(this.baseUrl + 'get-tool', { params: headerData });
    return this.http.get<any>(this.CoreUrl + 'PMTool/getPMTool', {
      params: headerData,
    });
  }

  addTool(data: any): Observable<any[]> {
    // return this.http.post<any>(this.baseUrl + 'add-tool', data);
    return this.http.post<any>(this.CoreUrl + 'PMTool/addPMTool', data);
  }

  updateTool(data: any): Observable<any[]> {
    // return this.http.put<any>(this.baseUrl + 'update-tool', data);
    return this.http.put<any>(this.CoreUrl + 'PMTool/updatePMTool', data);
  }

  deleteTool(data: any): Observable<any> {
    // return this.http.delete<any>(this.baseUrl + `delete-tool/${data.ID}`);
    return this.http.delete<any>(
      this.CoreUrl + `PMTool/deletePMTool/${data.ID}`
    );
  }

  getPrevFrequency(headerData: any): Observable<any[]> {
    // return this.http.get<any>(this.baseUrl + 'get-pm-frequency', { params: headerData });
    return this.http.get<any>(this.CoreUrl + 'PMFrequency/GetPMFrequency', {
      params: headerData,
    });
  }

  addPrevFrequency(data: any): Observable<any[]> {
    // return this.http.post<any>(this.baseUrl + 'add-pm-frequency', data);
    return this.http.post<any>(
      this.CoreUrl + 'PMFrequency/addPMFrequency',
      data
    );
  }

  updatePrevFrequency(data: any): Observable<any[]> {
    // return this.http.put<any>(this.baseUrl + 'update-pm-frequency', data);
    return this.http.put<any>(
      this.CoreUrl + 'PMFrequency/updatePMFrequency',
      data
    );
  }

  deletePrevFrequency(data: any): Observable<any> {
    // return this.http.delete<any>(this.baseUrl + `delete-pm-frequency/${data.ID}`);
    return this.http.delete<any>(
      this.CoreUrl + `PMFrequency/deletePMFrequency/${data.ID}`
    );
  }

  getPrevTask(headerData: any): Observable<any[]> {
    return this.http.get<any>(this.CoreUrl + 'PMTask/GetPMTask', {
      params: headerData,
    });
  }

  addPrevTask(data: any): Observable<any[]> {
    // return this.http.post<any>(this.baseUrl + 'add-pm-task', data);
    return this.http.post<any>(this.CoreUrl + 'PMTask/addPMTask', data);
  }

  updatePrevTask(data: any): Observable<any[]> {
    // return this.http.put<any>(this.baseUrl + 'update-pm-task', data);
    return this.http.put<any>(this.CoreUrl + 'PMTask/updatePMTask', data);
  }

  deletePrevTask(data: any): Observable<any> {
    // return this.http.delete<any>(this.baseUrl + `delete-pm-task/${data.ID}`);
    return this.http.delete<any>(
      this.CoreUrl + `PMTask/DeletePMTask/${data.ID}`
    );
  }

  PMMasterUpload(data: any): Observable<any[]> {
    // return this.http.post<any>(this.baseUrl + 'add-master-pm', data);
    return this.http.post<any>(
      this.CoreUrl + 'PMConfiguration/addMasterPM',
      data
    );
  }

  addUserWiseNotification(data: any): Observable<any[]> {
    // return this.http.post<any>(this.NotificationUrl + 'add-notifications-userwise', data);
    return this.http.post<any>(
      this.CoreUrl + 'Notification_Lean/AddUserWiseNotifications',
      data
    );
  }

  addRoleWiseNotification(data: any): Observable<any[]> {
    return this.http.post<any>(
      this.NotificationUrl + 'add-notifications-rolewise',
      data
    );
  }

  addDepartmentWiseNotification(data: any): Observable<any[]> {
    // return this.http.post<any>(this.NotificationUrl + 'add-notifications-departmentwise', data);
    return this.http.post<any>(
      this.CoreUrl + 'Notification_Lean/AddDepartmentWiseNotifications',
      data
    );
  }

  GetTreeMasterData(data: any): Observable<any[]> {
    return this.http.post<any>(this.CoreUrl + 'Common/GetTreeMasterData', data);
  }

  getUnitData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.CoreUrl + 'Dashboard/GetUnitList', data);
  }

  updateTaskStatus(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.CoreUrl + 'PMTask/UpdateTaskStatus',
      data
    );
  }

  getdropdowndatabyId(data: any): Observable<any> {
    return this.http.post<any>(
      this.CoreUrl + 'PMQualityCheckList/GetdropdowndatabyDetailId',
      data
    );
  }

  getItemTypes(): Observable<any> {
    return this.http.get<any>(this.CoreUrl + 'PMQualityTypes/GetItemTypes');
  }

  savedropdownitem(data: any) {
    return this.http.post(
      this.CoreUrl + 'PMQualityChecklist/SaveDropDownItem',
      data
    );
  }

  deleteItemdropdown(data: any) {
    return this.http.post(
      this.CoreUrl + 'PMQualityChecklist/DeleteDropdownElement',
      data
    );
  }

  AddCheckListsByTaskId(data: any) {
    return this.http.post(
      this.CoreUrl + 'PMQualityChecklist/AddCheckListsByTaskId',
      data
    );
  }

  GetCheckListByTaskId(id: number): Observable<any> {
    const params = new HttpParams().set('id', id.toString());
    return this.http.get<any>(
      `${this.CoreUrl}PMQualityChecklist/GetCheckListByTaskId`,
      { params }
    );
  }

  UpdateCheckListsByTaskId(data: any) {
    return this.http.post(
      this.CoreUrl + 'PMQualityChecklist/UpdateCheckListsByTaskId',
      data
    );
  }

  GetLineByPlant(data: any) {
    return this.http.post(this.CoreUrl + 'Common/GetLineByPlantCode', data);
  }

  GetUnitsByLineId(data: any) {
    return this.http.post(this.CoreUrl + 'Common/GetUnitsByLineId', data);
  }

  GetUnitByPlant(data: any) {
    return this.http.post(this.CoreUrl + 'Common/GetUnitByPlant', data);
  }

  GetComponentByUnit(data: any) {
    return this.http.post(this.CoreUrl + 'Common/GetComponentByUnit', data);
  }

  getAllQualityCheckListsNamesPreventiveMiantenance(
    data: any
  ): Observable<any[]> {
    return this.http.post<any>(
      this.CoreUrl +
        'PMQualityChecklist/GetAllQualityCheckListsNamesPreventiveMiantenance',
      data
    );
  }

  getQualityCheckListExecPMData(data: any): Observable<any[]> {
    return this.http.post<any>(
      this.CoreUrl + 'PMQualityChecklist/GetQualityCheckListExecPMData',
      data
    );
  }

  getQualityChecklistPMDetailsData(data: any): Observable<any[]> {
    return this.http.post<any>(
      this.CoreUrl + 'PMQualityChecklist/QualityChecklistExecutionPMDetails',
      data
    );
  }
}
